export default __webpack_public_path__ + "static/media/featureProduct.068cfc6d.svg";